module.exports = __webpack_public_path__ + "static/facts-8705385ac57a471df5f5b2f80c204fd0.png";